




















































import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import FileInput from '@/components/common/inputs/FileInput.vue'

@Component({
  components: {
    FileInput,
    Loading: () => import('@/components/common/loadings/UploadLoading.vue')
  }
})
export default class DocumentUpload extends Vue {
  $store!: ExStore
  file = {
    name: '',
    base64: ''
  }
  title = ''
  fileSelect = false
  loading = false

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get patientId() {
    return this.userInfo.id
  }

  async upload() {
    // TODO: エラー処理など。
    if (!this.file.base64) return
    this.loading = true
    try {
      await this.$api.document.create({
        patientId: this.patientId,
        payload: {
          title: this.title,
          fileName: this.file.name,
          fileContent: this.file.base64
        }
      })
      this.$router.push({
        name: 'PatientDocumentList'
      })
    } catch (e) {
      console.error(e)
      this.loading = false
    }
  }
}
